import React, { useState, useEffect } from 'react';
import { useHelp } from '../context/HelpContext';
import Draggable from 'react-draggable';
import { Paper, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReactMarkdown from 'react-markdown';

const HelpViewer = () => {
  const { isHelpVisible, helpKey, hideHelp } = useHelp();
  const [markdown, setMarkdown] = useState('');
  const [title, setTitle] = useState('Help');

  useEffect(() => {
    if (isHelpVisible && helpKey) {
      // Dynamically import the markdown file
      import(`../help/${helpKey}.md`)
        .then(res => {
          return fetch(res.default);
        })
        .then(response => response.text())
        .then(text => {
          // Extract title from the first line if it's a heading
          const lines = text.split('\n');
          const firstLine = lines[0];
          if (firstLine.startsWith('# ')) {
            setTitle(firstLine.substring(2));
            setMarkdown(lines.slice(1).join('\n'));
          } else {
            setTitle('Help'); // Default title
            setMarkdown(text);
          }
        })
        .catch(err => {
          console.error(`Failed to load help content for ${helpKey}:`, err);
          setMarkdown('Could not load help content.');
          setTitle('Error');
        });
    }
  }, [isHelpVisible, helpKey]);

  if (!isHelpVisible) {
    return null;
  }

  return (
    <Draggable handle=".handle">
      <Paper 
        elevation={8} 
        sx={{
          position: 'fixed',
          top: '100px',
          right: '20px',
          width: '800px',
          zIndex: 1301, // Higher than other dialogs
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          overflow: 'hidden',
          border: '1px solid #ccc'
        }}
      >
        <Box 
          className="handle" 
          sx={{
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            p: 1, 
            backgroundColor: 'primary.main', 
            color: 'primary.contrastText', 
            cursor: 'move'
          }}
        >
          <Typography variant="h6" sx={{ fontSize: '1rem' }}>{title}</Typography>
          <IconButton onClick={hideHelp} size="small">
            <CloseIcon sx={{ color: 'primary.contrastText' }} />
          </IconButton>
        </Box>
        <Box sx={{ p: 3, maxHeight: '700px', overflowY: 'auto', fontSize: '1.1rem', '& h3': { marginTop: '1.5rem', marginBottom: '1rem' }, '& p, & li': { lineHeight: '1.6' } }}>
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </Box>
      </Paper>
    </Draggable>
  );
};

export default HelpViewer;
